import './App.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import MainRouter from './components/MainRouter';
import CssBaseline from '@mui/material/CssBaseline';
import store from './Store';
import CanvasAnimation from './components/resuableComponents/CanvasAnimation';
// import GetQuote from './components/resuableComponents/GetQuote';
function App() {
	return (
		<>
			<Provider store={store}>
				
				<BrowserRouter>
				 <CssBaseline />
					<MainRouter />
				</BrowserRouter>
			</Provider>
		</>
	);
}

export default App;
